export default __webpack_public_path__ + "static/media/icon__12.cbb757c7.svg";